module.exports = __webpack_public_path__ + "img/carousel-next.bb18fa0a.svg";